import isFunction from 'lodash-es/isFunction';

/**
 * This function gets an array of elements of any kind and an array of
 * functions which will be called to test conditions and will return element
 * whose index equals the matching condition's index
 *
 * @param arr An array of elements of any kind
 * @param conditions An array of conditions, which will be tested in order to determine which index of the array will be returned
 * @param defaultIndex The return value in case that no condition matches
 * @returns An element of the array if any of the conditions matches or the defaultIndex otherwise.
 */
export function getIndex<T = unknown>(
  arr: T[],
  conditions: (boolean | (() => boolean))[],
  defaultIndex?: number,
): T {
  for (let i = 0; i < conditions.length; i++) {
    if (
      (typeof conditions[i] === 'boolean' && conditions[i]) ||
      (isFunction(conditions[i]) && (conditions[i] as () => boolean)())
    )
      return arr[i];
  }
  return arr[defaultIndex ?? -1];
}
